module.exports = __webpack_public_path__ + "static/media/gopuram.15693f2a.svg";